import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postSwipe,
  type PostSwipeParams,
  type PostSwipeResponse,
} from '@services/MatchesService';

export type UsePostSwipeParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostSwipeResponse,
    unknown,
    string,
    PostSwipeParams,
    PostSwipeResponse
  >;
};

export const postSwipeMutationKey = 'post-swipe';

export const usePostSwipe = ({ mutationOptions }: UsePostSwipeParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostSwipeResponse,
    unknown,
    string,
    PostSwipeParams
  >(postSwipeMutationKey, (_url, { arg }) => postSwipe(arg), mutationOptions);

  return {
    trigger,
    ...swrResponse,
  };
};
